import React, { useState } from 'react'
import { Box, Typography, Tooltip as MuiTooltip } from '@material-ui/core'
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts'

import LoadingSpinner from 'components/loading-spinner'
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined'

const PaymentsByMonthChart = ({
  data,
  title,
  className,
  loading,
  error,
  tooltip,
}) => {
  const [showTooltip, setShowTooltip] = useState(false)

  const renderContent = () => {
    if (loading) return <LoadingSpinner />
    if (error) return <Box p={3}>Error loading chart data</Box>
    if (!data?.length) return <Box p={3}>No payment data available</Box>

    return (
      <ResponsiveContainer width="100%" height="100%">
        <LineChart
          data={data}
          margin={{
            top: 5,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis
            dataKey="month"
            axisLine={false}
            tickLine={false}
            tick={{ fontSize: 12 }}
          />
          <YAxis
            axisLine={false}
            tickLine={false}
            tick={{ fontSize: 12 }}
            tickFormatter={value => `$${value.toLocaleString()}.00`}
          />
          <Tooltip
            formatter={value => [`$${value.toLocaleString()}.00`, 'Total']}
          />
          <Line
            type="monotone"
            dataKey="total"
            stroke="#2053FF"
            strokeWidth={2}
            dot={{ fill: '#2053FF', r: 4 }}
            activeDot={{ r: 6 }}
            name="Total"
            animationDuration={1800}
            animationBegin={300}
          />
        </LineChart>
      </ResponsiveContainer>
    )
  }

  return (
    <Box
      className={className}
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
      onFocus={() => setShowTooltip(true)}
      onBlur={() => setShowTooltip(false)}
      style={{ position: 'relative' }}
    >
      <Typography variant="h6" style={{ marginBottom: '16px' }}>
        {title}
      </Typography>
      {tooltip && showTooltip && (
        <Box
          style={{
            position: 'absolute',
            top: '8px',
            right: '8px',
            zIndex: 1,
          }}
        >
          <MuiTooltip title={tooltip} placement="top">
            <InfoOutlinedIcon
              style={{ fontSize: 18, color: '#666', cursor: 'help' }}
            />
          </MuiTooltip>
        </Box>
      )}
      <Box style={{ height: 420 }}>{renderContent()}</Box>
    </Box>
  )
}

export default PaymentsByMonthChart
